import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ChatPremium = function ChatPremium(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 15C20 15.551 19.551 16 19 16H8.554C8.011 16 7.477 16.148 7.01 16.428L4 18.234V5C4 4.449 4.449 4 5 4H19C19.551 4 20 4.449 20 5V15ZM19 2H5C3.346 2 2 3.346 2 5V20C2 20.36 2.194 20.693 2.507 20.87C2.66 20.957 2.83 21 3 21C3.178 21 3.356 20.953 3.515 20.857L8.039 18.143C8.195 18.049 8.373 18 8.554 18H19C20.654 18 22 16.654 22 15V5C22 3.346 20.654 2 19 2Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.7807 14.4775C14.7017 14.4775 14.6222 14.459 14.5492 14.421L11.9997 13.089L9.45069 14.421C9.28169 14.5085 9.07769 14.4935 8.92469 14.3815C8.77069 14.2695 8.69419 14.08 8.72669 13.8925L9.21219 11.0785L7.15219 9.086C7.01519 8.9535 6.96569 8.7545 7.02419 8.5725C7.08269 8.3915 7.23919 8.259 7.42819 8.232L10.2782 7.818L11.5522 5.255C11.7212 4.915 12.2787 4.915 12.4477 5.255L13.7217 7.818L16.5717 8.232C16.7607 8.259 16.9172 8.3915 16.9757 8.5725C17.0342 8.7545 16.9847 8.9535 16.8477 9.086L14.7877 11.0785L15.2732 13.8925C15.3057 14.08 15.2287 14.2695 15.0752 14.3815C14.9882 14.4455 14.8847 14.4775 14.7807 14.4775ZM20 15C20 15.551 19.551 16 19 16H8.554C8.011 16 7.477 16.148 7.01 16.428L4 18.234V5C4 4.449 4.449 4 5 4H19C19.551 4 20 4.449 20 5V15ZM19 2H5C3.346 2 2 3.346 2 5V20C2 20.36 2.194 20.693 2.507 20.87C2.66 20.957 2.83 21 3 21C3.178 21 3.356 20.953 3.515 20.857L8.039 18.143C8.195 18.049 8.373 18 8.554 18H19C20.654 18 22 16.654 22 15V5C22 3.346 20.654 2 19 2Z",
      fill: color
    })]
  });
};
export default ChatPremium;